import { get } from "helpers/api_helper"

export const getReports = async ({ payload }) => {
  const { from, to, ...params } = Object.assign({}, ...payload)
  const utcDate = value => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) throw new Error("Invalid report date")
    const date = new Date(value + "T00:00:00.000Z")
    if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value) throw new Error("Invalid report date")
    return date
  }
  if (from) params.dateFrom = utcDate(from).toISOString()
  if (to) { const end = utcDate(to); end.setUTCDate(end.getUTCDate() + 1); params.dateTo = end.toISOString() }
  const response = await get(`/accounts/reports?${new URLSearchParams(params).toString()}`)
  if (!Array.isArray(response?.data?.reports) || !Number.isSafeInteger(response.data.length) || response.data.length < 0) throw new Error("Invalid reports response")
  return response
}
export const getReport = reportId => get(`/accounts/reports/${reportId}`)
